import React from "react";
import * as BS from "react-bootstrap";

interface OptionalProps {
    bsSize?: BS.Sizes;
    headerClassName?: string;
    labelCancel?: JSX.Element | string;
    labelProceed?: JSX.Element | string;
    onCancel?: () => void;
    onProceed?: () => void;
    renderBody?: (data: any) => JSX.Element | null;
    processingMessage?: JSX.Element | string;
    showProcessing?: boolean;
}

type OwnProps = OptionalProps & {
    title: JSX.Element | string;
};

interface OwnState {
    processing: boolean;
    show: boolean;
    data?: any;
}

export class ConfirmModal extends React.Component<OwnProps, OwnState> {

    public static defaultProps: OptionalProps = {
        headerClassName: "info",
        labelCancel: "Cancel",
        labelProceed: "Proceed",
        processingMessage: <BS.Button bsStyle="primary"><i className="fa fa-spinner fa-spin"></i> Processing&hellip;</BS.Button>,
        showProcessing: true,
    };

    public constructor(props: any) {
        super(props);
        this.state = {
            processing: false,
            show: false,
        };
    }

    /**
     * Closes the confirmation dialog and resets its state
     */
    public async close() {
        await this.setStateAsync({ ...this.state, processing: false, data: undefined, show: false });
    }

    /**
     * Opens the confirmation dialog and optionally sets a reference object
     * (handy when needing to manipulate object upon proceed click)
     * @param ref The optional reference object
     */
    public show(ref?: any) {
        this.setState({ ...this.state, processing: false, data: ref, show: true });
    }

    /**
     * Returns the reference object
     */
    public getRef() {
        return this.state.data;
    }

    public render() {
        const modalProps: BS.ModalProps = {
            bsSize: this.props.bsSize,
            backdrop: "static",
            keyboard: true,
            onHide: () => {},
            show: this.state.show,
        };

        let footer = <BS.Modal.Footer>
                <BS.Button bsStyle="link" onClick={() => this.onCancelClick()}>{this.props.labelCancel}</BS.Button>
                <BS.Button bsStyle="primary" onClick={() => this.onProceedClick()}>{this.props.labelProceed}</BS.Button>
            </BS.Modal.Footer>;

        if (this.state.processing && this.props.showProcessing)
            footer = <BS.Modal.Footer>{this.props.processingMessage}</BS.Modal.Footer>;

        const body = typeof this.props.renderBody === "function"
            ? this.props.renderBody(this.state.data)
            : null;

        return <BS.Modal { ...modalProps }>
            <BS.Modal.Header bsClass={"modal-header alert-" + (this.props.headerClassName)}>
                <BS.Modal.Title>{this.props.title}</BS.Modal.Title>
            </BS.Modal.Header>

            <BS.Modal.Body>
                {this.props.children}
                {body}
            </BS.Modal.Body>

            {footer}
        </BS.Modal>;
    }

    /**
     * Internal handling of cancel click
     */
    private onCancelClick() {
        if (this.props.onCancel)
            this.props.onCancel();

        this.close();
    }

    /**
     * Internal handling of proceed click
     */
    private onProceedClick() {
        if (this.props.onProceed)
            this.props.onProceed();

        this.setState({ ...this.state, processing: true });
    }

    private setStateAsync(newState: OwnState) {
        return new Promise((resolve, reject) => {
            try {
                this.setState({
                    ...(this.state as any),
                    ...(newState as any),
                }, () => {
                    resolve(this.state);
                });
            }
            catch (err) {
                reject(err);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ConfirmModal.tsx